import { render, staticRenderFns } from "./ForgotPasswordPage.vue?vue&type=template&id=f02f96b0&scoped=true&"
import script from "./ForgotPasswordPage.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordPage.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordPage.vue?vue&type=style&index=0&id=f02f96b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02f96b0",
  null
  
)

export default component.exports